
import { requireImgAssets } from '@/utils/utils'

// CMS 组装取图配置：接口不返回图片，Tab 大图（product-item-img）按 productType 固定映射，与各站点 data.js 无关
const MB_NEW_02 = requireImgAssets('@/assets/img/home/product_mb_new_02.svg')
const MB_NEW_03 = requireImgAssets('@/assets/img/home/product_mb_new_03.png')
const MB_NEW_04 = requireImgAssets('@/assets/img/home/product_mb_new_04.png')
const IMG_MB_CN_KR = requireImgAssets('@/assets/img/home/product_mb_cn_kr.svg')
const IMG_MB_SEA = requireImgAssets(
  '@/assets/img/home/product_mb_vn_th_my_sg_ph.svg'
)
const IMG_MB_WEST = requireImgAssets(
  '@/assets/img/home/product_mb_us_eu_au_fr_de.svg'
)
// 站点 → 大图分组（type 1 与兜底类型按站点取用）
const IMG_MB_BY_SITE = {
  cn: IMG_MB_CN_KR,
  vn: IMG_MB_SEA,
  th: IMG_MB_SEA,
  my: IMG_MB_SEA,
  sg: IMG_MB_SEA,
  ph: IMG_MB_SEA,
  us: IMG_MB_WEST,
  eu: IMG_MB_WEST,
  au: IMG_MB_WEST,
  fr: IMG_MB_WEST,
  de: IMG_MB_WEST,
}
// productType → 大图 img_mb；随站点变化的统一用 function(site) 表达
const PRODUCT_TYPE_IMG_MB = {
  1: (site) => IMG_MB_BY_SITE[site] || IMG_MB_WEST,
  2: () => MB_NEW_02,
  4: () => MB_NEW_03,
  5: () => MB_NEW_04,
}
// Menu 返回映射表外的新 productType 时兜底：大图按站点分组取用
const PRODUCT_TYPE_IMG_MB_FALLBACK = (site) =>
  IMG_MB_BY_SITE[site] || IMG_MB_WEST

// 首页产品区走 CMS 配置（与 PC 端 product.vue 同一套链路）：
//   Tab 个数/顺序/标题 = getLogisticsServiceMenu 的 result.product.children
//     （layouts/base.vue 已统一拉取并缓存在 Vuex state.productMenus，本组件不重复发请求）
//   Tab 内产品列表     = getLogisticsServiceMain({type:1})，按 tab 上 CMS 配置的 productType 匹配
//   标题 name / 描述 productDescription / 跳转 url / sort 有值升序在前、为空按接口顺序垫后
// 兜底只有一种情况：接口失败/超时，回落 data.js 静态内容；
// 接口正常返回（包括内容为空、未配 productType）一律按 CMS 组装，空就是该站点没产品，不兜底
export default {
  props: {
    clientData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 展示模型：初始为 data.js 静态内容（兜底），接口成功后整块替换为 CMS 配置
      mergedData: this.clientData,
      // Main 接口返回的产品列表（null=还没回来）
      mainList: null,
      // 已组装标志：组装只做一次
      cmsApplied: false,
      // 接口等待期骨架屏：组装成功/接口失败/超时都会置 false
      showSkeleton: true,
      // 接口一直 pending（如网络挂起）时的安全阀定时器
      skeletonTimer: null,
    }
  },
  watch: {
    // base.vue 拉完 Menu 会 commit 进 store，可能晚于本组件 mounted；
    // Menu 到了就试着组装（Main 没到就等着，Main 的 then 里也会试着组装）
    '$store.state.productMenus'() {
      this.tryMerge()
    },
  },
  mounted() {
    // this.clientData = this.clientData[0].children.map(item => {
    //   return item.children.fitler(it => {
    //     return it.subTitle
    //   })
    // })
    console.log('clientData---', this.clientData)
    // 安全阀：接口等待期最长 5 秒，超时回落静态兜底，不能一直停在骨架屏
    // （axios 无全局 timeout 配置，请求可能长时间 pending）
    this.skeletonTimer = setTimeout(() => {
      this.showSkeleton = false
    }, 5000)
    this.fetchMain()
    this.tryMerge()
  },
  beforeDestroy() {
    if (this.skeletonTimer) {
      clearTimeout(this.skeletonTimer)
      this.skeletonTimer = null
    }
  },
  methods: {
    // 仅展示"有产品"的 Tab，空骨架 Tab 不渲染
    visibleTabs(item) {
      return (item.children || []).filter(
        (tab) => tab.children && tab.children.length
      )
    },
    // 发 Main 请求（产品详情，参数固定 {type:1}），结果存 mainList。
    // 仅接口失败/超时才回落静态兜底；正常返回（包括空数组）都走组装
    fetchMain() {
      this.$API.product
        .getLogisticsServiceMain({ type: 1 })
        .then((res) => {
          this.mainList = res?.result || []
          this.tryMerge()
        })
        .catch((e) => {
          console.log('home product config fetch error---', e)
          // 接口失败：关骨架屏，渲染 data.js 静态兜底
          this.showSkeleton = false
        })
    },
    // 组装：Menu（store）和 Main（mainList）都到了才合并，合并一次就置标志
    tryMerge() {
      if (this.cmsApplied) return
      if (!this.$store.state.productMenusLoaded) return // Menu 没回来，等着
      if (this.mainList === null) return // Main 没回来，等着
      const menuProduct = (this.$store.state.productMenus || []).find(
        (m) => m.name === 'product'
      )
      // 两个接口都正常返回了就组装，CMS 配成啥样渲染啥样（空=该站点没产品，不兜底）
      this.applyProductConfig(menuProduct?.children || [], this.mainList)
    },
    applyProductConfig(menuTabs, list) {
      // Tab：个数/顺序/标题完全以 Menu 接口 product.children 为准（配置啥是啥）
      // 大图不走 CMS 也不走 data.js：按 productType 查 PRODUCT_TYPE_IMG_MB 固定映射
      const site = this.$route.params.site
      const tabs = menuTabs
        .map((mt) => {
          // Menu 的 tab 对象上有 CMS 配置的 productType，用它关联 Main 接口的产品
          const productType = Number(mt.productType) || null
          // 映射表外的类型统一兜底图，防 Menu 返回新 productType 时大图空白
          const imgMb =
            PRODUCT_TYPE_IMG_MB[productType] || PRODUCT_TYPE_IMG_MB_FALLBACK
          return {
            raw: true,
            productType,
            title: mt.cname || mt.name,
            children: [],
            img_mb: imgMb(site),
          }
        })
        // 没配 productType 的 Tab 匹配不到任何产品，不并入 CMS 结构（即不展示）
        .filter((t) => t.productType)
      list.forEach((it) => {
        const tab = tabs.find((t) => t.productType === Number(it.productType))
        if (!tab) return
        const hasSort =
          it.sort !== '' &&
          it.sort !== null &&
          it.sort !== undefined &&
          !isNaN(Number(it.sort))
        const path = this.toInternalPath(it.url)
        tab.children.push({
          raw: true,
          title: it.name,
          subTitle: it.productDescription || '',
          path,
          params: {},
          // 接口给的是含站内前缀的绝对链接，转成站内路径后整路径使用
          rootReplace: path !== '#',
          _sort: hasSort ? Number(it.sort) : null,
        })
      })
      // sort 有值的在前按升序；为空的保持接口返回顺序垫后
      tabs.forEach((tab) => {
        const withSort = tab.children
          .filter((c) => c._sort !== null)
          .sort((a, b) => a._sort - b._sort)
        const rest = tab.children.filter((c) => c._sort === null)
        tab.children = withSort.concat(rest)
      })
      // 组对象只装 CMS 组装的 Tab 列表；区块标题在模板写死，不在这里管
      this.mergedData = [{ children: tabs }]
      this.cmsApplied = true
      this.showSkeleton = false
      // 打印最终组装结果（深拷贝去掉 Vue 响应式包装），供核对 DOM 是否有丢内容
      console.log(
        'home product assembled data---',
        JSON.parse(JSON.stringify(this.mergedData))
      )
    },
    // 把 CMS 的绝对链接转成站内路径，非法链接返回 '#'
    toInternalPath(url) {
      const reg = /(http(s)?:\/\/)?[a-z0-9A-Z]+\.(com|cn|net)(.+)?/
      if (!reg.test(url)) return '#'
      try {
        if (/^https?:\/\//.test(url)) {
          const parsed = new URL(url)
          const path = `${parsed.pathname}${parsed.search}${parsed.hash}`
          return path.startsWith('/') ? path : '#'
        }
        return url
      } catch (e) {
        console.log('toInternalPath error---', url, e)
        return '#'
      }
    },
  },
}
